const Spin: React.FC = () => {
  return (
    <svg version="1.1" id="Spin" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
      viewBox="0 0 238.6 242.4" className="spin">
      <g>
        <rect x="113.1" y="-0.4" className="spinColor st1" width="17.9" height="51.8" />

        <rect x="56.4" y="16.3" transform="matrix(0.809 -0.5878 0.5878 0.809 -12.3536 46.4464)" className="spinColor st2" width="17.9" height="51.8" />

        <rect x="20.3" y="63.1" transform="matrix(0.309 -0.9511 0.9511 0.309 -64.5172 89.3163)" className="spinColor st3" width="17.9" height="51.8" />

        <rect x="18.6" y="122.2" transform="matrix(-0.309 -0.9511 0.9511 -0.309 -104.8586 220.1216)" className="spinColor st4" width="17.9" height="51.8" />
        <rect x="52" y="171" transform="matrix(-0.809 -0.5878 0.5878 -0.809 -5.564 392.0822)" className="spinColor st5" width="17.9" height="51.8" />

        <rect x="107.7" y="190.9" transform="matrix(-1 -4.040437e-09 4.040437e-09 -1 233.2015 433.5957)" className="spinColor st6" width="17.9" height="51.8" />

        <rect x="164.4" y="174.2" transform="matrix(-0.809 0.5878 -0.5878 -0.809 431.1715 260.1603)" className="spinColor st7" width="17.9" height="51.8" />

        <rect x="200.5" y="127.4" transform="matrix(-0.309 0.9511 -0.9511 -0.309 419.92 1.517)" className="spinColor st8" width="17.9" height="51.8" />

        <rect x="202.1" y="68.3" transform="matrix(0.309 0.9511 -0.9511 0.309 235.4523 -135.6546)" className="spinColor st9" width="17.9" height="51.8" />

        <rect x="168.8" y="19.5" transform="matrix(0.809 0.5878 -0.5878 0.809 60.6332 -95.7765)" className="spinColor st10" width="17.9" height="51.8" />
      </g>
    </svg>

  )
}

export default Spin